import React, {useState, useEffect, useRef} from 'react';
import {
  Link,
  useParams,
  useHistory
} from "react-router-dom";
import SubForm from '../../components/SubEditForm';
import {uploadFile} from '../../Utils.js';
import slugify from 'slugify';

export default function AccountSubAdd({ showMessage }) {
  const [sub, setSub] = useState({});
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState();
  const [login, setLogin] = useState(false);
  const [valid, setValid] = useState('');

  document.title = 'Add a New Subscription | Sublunary Admin'

  let history = useHistory();

  const newCover = useRef(null);

  const setDefaultSub = () => {
    setSub({
      "title": "",
      "subtitle": "",
      "public": true,
      "description": "",
      "region": "US",
      "productId": "",
      "prices": {
        "list": 0.00,
        "retail": 0.00,
        "retailStripe": '',
        "period": "per month",
        "recurring": true,
        "gift": false,
      },
      "cover": ""
    });
  }

  useEffect(() => {
    setDefaultSub();
  }, []);

  const submit = async (another) => {
    let newsub = {...sub}
    setUploading(true);
    if (newCover.current && newCover.current.files.length > 0) {
      showMessage({text: 'Hold tight! We\'re uploading your files', temp: true, type: 'info'});
      newsub.cover = await window.ASTERISM.uploadFile(newCover);
    }
    setUploading(false);
    let data = await window.ASTERISM.makeRequest('create-sub', 'POST', newsub)
    if (data.ok) {
      showMessage({text: 'Subscription successfully created!', temp: true, type: 'success'});
      if (another) {
        setDefaultSub();
      } else {
        history.push(`/my-account/sub/${data.id}`);
      }
    } else {
      showMessage({text: 'Something went wrong. Check your product ID to make sure a product with this ID doesn\'t already exist.', temp: true, type: 'warn'});
    }
  }

  if (error) {
    return (
      <div className='edit-bar'><div className='edit-title'>{error} {login && <Link to={`/login?return=${window.location.pathname}`}><button className='secondary-submit'>Login</button></Link>}</div></div>
    )
  }

  return (
    <div className=''>
      <div className='edit-bar'>
        <Link className='back-link' to='/my-account/subscriptions'>⟵ Back to subs</Link>
        <div>
          <button className='main-submit' onClick={() => {submit(false)}}>Save</button>
          <button className='main-submit' onClick={() => {submit(true)}}>Save and Create Another</button>
        </div>
      </div>
      <SubForm setSub={setSub} sub={sub} newCover={newCover} uploading={uploading}/>
    </div>
  )
}
